
import { Component, Vue, Prop, Mixins } from 'vue-property-decorator'
import { TranslationHandler } from '../mixins/TranslationHandler'
import { Getter } from 'vuex-class'
import Icon from 'umg-components/src/components/atoms/Icon.vue'

@Component({
  components: { Icon },
})
export default class Services extends Mixins(TranslationHandler) {
  @Getter visualPrimaryColor!: string
  @Getter partyServices!: string[]
}
